export const NOT_SUITABLE_ID = "1"
export const UNSUITABLE_LEVEL_ID = "2"
export const POOR_COHESION_ID = "3"
export const WRONG_INSTRUMENT_ID = "4"
export const POOR_REPERTOIRE_ID = "5"
export const SCHEDULE_CHANGE_ID = "6"
export const MOVING_ID = "7"
export const LEVEL_NOT_SUITABLE_ID = "8"
export const OTHER_ID = "11"

export const STOP_REASONS = [
    {
        id: NOT_SUITABLE_ID,
        label: "Les méthodes d'apprentissage ne me conviennent pas",
    },
    {
        id: UNSUITABLE_LEVEL_ID,
        label: "Le niveau du cours est inadapté"
    },
    {
        id: POOR_COHESION_ID,
        label: "Mauvaise cohésion du groupe"
    },
    {
        id: WRONG_INSTRUMENT_ID,
        label: "Erreur de choix d'instrument"
    },
    {
        id: POOR_REPERTOIRE_ID,
        label: "Problème de répertoire"
    },
    {
        id: SCHEDULE_CHANGE_ID,
        label: "Changement de planning"
    },
    {
        id: MOVING_ID,
        label: "Déménagement"
    },
    {
        id: LEVEL_NOT_SUITABLE_ID,
        label: "Le niveau du cours est inadapté"
    },
    {
        id: OTHER_ID,
        label: "Autre..."
    },
];